import { render, staticRenderFns } from "./VoterPreferences.vue?vue&type=template&id=9e5d74d4"
import script from "./VoterPreferences.vue?vue&type=script&lang=js"
export * from "./VoterPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports